// ##### 24-06-12 Komarov
import React from 'react';
import { Media } from '../../../../../helpers/MediaConfig';
// ##### 25-05-21 Komarov
import TopMenuRightDivPartForDesktop from './TopMenuRightDivPartForDesktop';
import TopMenuRightDivPartForNotDesktop from './TopMenuRightDivPartForNotDesktop';

// ##### Komarov 2025-07-14
const TopMenuRightDiv = ({ className }) => {
  return (
    // ##### Komarov 2025-07-24
    <div className={className} data-component="TopMenuRightDivSsr">
      {/* TODO: Вставить сюда перевод текста "LOG OUT" */}
      {/* TODO: Вставить сюда перевод текста "SIGN IN" */}

      {/* ##### 24-06-12 Komarov */}
      <Media lessThan="Laptop-1024-1440">
        <TopMenuRightDivPartForNotDesktop />
      </Media>
      <TopMenuRightDivPartForDesktop />
    </div>
  );
};

export default TopMenuRightDiv;
